import styled from 'styled-components';
import { palette } from '@dev/ee-components';

export const CloseIconContainer = styled.div`
    width: 100%;
    height: 68px;
    svg {
        fill: #718096;
        top: 24px;
        right: 24px;
        position: absolute;
        cursor: pointer;
    }
`;

export const Overlay = styled.div`
    background: ${palette.snow[1]};
    height: max-content;
    min-height: 100vh;

    .MuiContainer-root {
        padding-top: 60px;
    }
`;
